<script>
import {defineComponent, computed} from "vue";
import {useStore} from "vuex";

import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default defineComponent({
  components: {DataTable, Column},
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const lang = computed(() => store.getters.getLang);
    const nameField = computed(() => `name_${lang.value}`);

    return {nameField};
  },
});
</script>

<template>
  <DataTable :value="categories" showGridlines tableStyle="min-width: 50rem" selectionMode="single">
    <Column field="id" header="ID"></Column>
    <Column field="name" header="Наименование категории">
      <template #body="slotProps">
        <router-link class="color-primary" :to="{ name: 'partner-category-view', params: {id: slotProps.data.id}}">
          {{ slotProps.data[nameField] }}
        </router-link>
      </template>
    </Column>
  </DataTable>
</template>